import { GridColumn } from 'src/components/GridWrapper';
import FileIconCell from 'src/components/custom-cells/FileIconCell';
import { FileIcon } from '../scan_manager/scanManagerColumns';

export const documentAttachmentColumns: GridColumn<any>[] = [
  {
    field: 'selected',
    title: '',
    width: '50px',
    menu: false,
  },
  {
    field: 'file',
    title: 'file',
    component: FileIconCell,
    headerCell: FileIcon,
    width: '50px',
    menu: false,
  },
  {
    field: 'originalFile',
    title: 'File Name',
    filter: 'text',
    format: '',
    dataType: 'string',
  },
  {
    field: 'createdBy',
    title: 'Upload By',
    filter: 'text',
    format: '',
    dataType: 'string',
  },
  {
    field: 'companyName',
    title: 'Company Name',
    filter: 'text',
    format: '',
    dataType: 'string',
  },
];
